import forDevice from '../../hoc/for-device';
import withLazy from '../../hoc/with-lazy';
export const ShowLiveCommentsDesktopLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-show-live-comments-desktop" */ './show-live-comments-desktop'),
    errorHandling: { type: 'HANDLE' },
});
export const ShowLiveCommentsMobileLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-show-live-comments-mobile" */ './show-live-comments-mobile'),
    errorHandling: { type: 'HANDLE' },
});
export const LoadMoreLiveDesktopLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-load-more-live-desktop" */ './load-more-live-desktop'),
    errorHandling: { type: 'HANDLE' },
});
export const LoadMoreLiveMobileLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-load-more-live-mobile" */ './load-more-live-mobile'),
    errorHandling: { type: 'HANDLE' },
});
export const ShowLiveComments = forDevice(ShowLiveCommentsMobileLazy, ShowLiveCommentsDesktopLazy);
export const LoadMoreLive = forDevice(LoadMoreLiveMobileLazy, LoadMoreLiveDesktopLazy);
export const SomeoneIsTyping = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-someone-is-typing" */ './someone-is-typing'),
    errorHandling: { type: 'HANDLE' },
});
export const LiveCommentIndicator = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-someone-is-typing" */ './live-comment-indicator'),
    errorHandling: { type: 'HANDLE' },
});
//# sourceMappingURL=index.js.map